/**
 * A/B test: does inserting the overview page between the family-trips landing page and the trip page
 * improve conversion? Assignment is server-side in proxy.ts. Eligibility is per-card, not per-page:
 * only blueprints in lovable-inspiration-pages.json have an overview page.
 */

/** Compare against a locale-stripped pathname — see stripLocalePrefix. */
export const OVERVIEW_EXPERIMENT_PATH = '/inspiration/family-trips';

/** Goes into requestSource.modifier. Must stay hyphen-free — stringifySource joins segments with '-'. */
export const OVERVIEW_EXPERIMENT_LP_SLUG = 'family';

/** Shared so proxy.ts and BlueprintCard cannot drift: a typo would route the treatment arm to control. */
export const OVERVIEW_EXPERIMENT_VARIANTS = {
  /** Routed via the overview page. */
  intermediate: 'intermediate',
  /** Straight to /journey-template/, i.e. the pre-experiment flow. */
  direct: 'direct'
} as const;

/** Identifies this experiment on the conversion event, so the attribute can be reused by later tests. */
export const OVERVIEW_EXPERIMENT_ID = 'overview';

/** Forces an arm for testing: /inspiration/family-trips?forceVariant=intermediate */
export const FORCE_VARIANT_PARAM = 'forceVariant';

export type OverviewExperimentVariant =
  (typeof OVERVIEW_EXPERIMENT_VARIANTS)[keyof typeof OVERVIEW_EXPERIMENT_VARIANTS];

export const isOverviewExperimentVariant = (value: unknown): value is OverviewExperimentVariant =>
  value === OVERVIEW_EXPERIMENT_VARIANTS.intermediate || value === OVERVIEW_EXPERIMENT_VARIANTS.direct;
